import { Grid } from 'semantic-ui-react';
import ParagraphText from '../components/ParagraphText';
import DateFormat from './DateFormat';
import React from 'react';

export default function CustomField({ type, value }) {
  const convertToBoolean = (value) => String(value).toLowerCase() === 'true';

  if (type === 'textarea') {
    return (
      <>
        <Grid.Column width={8} className="custom-field-value">
          <ParagraphText defaultValue={''} disabled={true} value={value} />
        </Grid.Column>
      </>
    );
  }
  if (type === 'textarea_with_formatting' || type === 'plain_text') {
    return (
      <Grid.Column width={16} className="custom-field-value">
        <div dangerouslySetInnerHTML={{ __html: value }} />
      </Grid.Column>
    );
  }
  if (type === 'url') {
    return (
      <>
        <Grid.Column width={8} className="custom-field-value">
          <a href={value} target="_blank" className="links" rel="noreferrer">
            {value}
          </a>
        </Grid.Column>
      </>
    );
  }
  if (type === 'date') {
    return (
      <>
        <Grid.Column width={8} className="custom-field-value date-value">
          <DateFormat date={value} inFormat={'DD-MMM-YYYY'}></DateFormat>
        </Grid.Column>
      </>
    );
  }
  if (type?.includes('multi_select')) {
    const combinedString = value?.join(', ');
    return (
      <>
        <Grid.Column width={8} className="custom-field-value">
          {combinedString}
        </Grid.Column>
      </>
    );
  }
  if (type === 'integer') {
    return (
      <>
        <Grid.Column width={8} className="custom-field-value" data-testid="integerNullable">
          {value ? value.toLocaleString() : ''}
        </Grid.Column>
      </>
    );
  }
  if (type === 'boolean') {
    return (
      <>
        <Grid.Column width={8} className="custom-field-value" data-testid="booleanNullable">
          {value == null ? '' : convertToBoolean(value) ? 'Yes' : 'No'}
        </Grid.Column>
      </>
    );
  }
  return (
    <>
      <Grid.Column width={8} className="custom-field-value">
        {value}
      </Grid.Column>
    </>
  );
}
